export default function Hero() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - 64;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      {/* Background decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-500/5 rounded-full blur-3xl" />
      </div>

      <div className="relative w-full max-w-[1440px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: Text Content */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag */}
            <div className="inline-flex items-center gap-2 bg-primary-100/80 text-primary-700 text-xs font-medium px-3 py-1.5 rounded-full mb-5">
              <i className="ri-fire-line text-sm" />
              <span>每日更新 · 片库全覆盖</span>
            </div>

            {/* H1 */}
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-4">
              番茄影视
              <span className="block text-primary-500">海量高清影视免费在线观看</span>
            </h1>

            {/* Slogan */}
            <p className="text-base md:text-lg text-foreground-600 font-medium mb-6">
              最新热播剧集、经典大片、热门综艺、人气动漫，一网打尽
            </p>

            {/* Description */}
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-7 max-w-xl mx-auto lg:mx-0">
              番茄影视大全汇聚全网优质影视资源，覆盖电影、电视剧、综艺、动漫等全类型片库。高清画质搭配智能加速引擎，告别缓冲等待，随时随地畅享流畅观影体验。每日实时更新最新片源，追剧看片一站搞定，满足全家人不同的观影口味。
            </p>

            {/* Stats */}
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center lg:text-left">
                <div className="text-xl md:text-2xl font-bold font-heading text-primary-500">10万+</div>
                <div className="text-xs text-foreground-500 mt-0.5">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block" />
              <div className="text-center lg:text-left">
                <div className="text-xl md:text-2xl font-bold font-heading text-accent-500">每日更新</div>
                <div className="text-xs text-foreground-500 mt-0.5">追剧不等待</div>
              </div>
              <div className="w-px h-10 bg-background-300 hidden sm:block" />
              <div className="text-center lg:text-left">
                <div className="text-xl md:text-2xl font-bold font-heading text-primary-500">高清流畅</div>
                <div className="text-xs text-foreground-500 mt-0.5">告别缓冲</div>
              </div>
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 text-background-50 px-7 py-3 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg" />
                立即探索热门榜单
              </a>
              <a
                href="#index"
                onClick={(e) => handleScroll(e, '#index')}
                className="whitespace-nowrap inline-flex items-center gap-2 border border-background-300 text-foreground-700 px-7 py-3 rounded-full font-medium text-sm hover:bg-background-100 hover:border-background-400 transition-colors cursor-pointer"
              >
                <i className="ri-grid-line text-lg" />
                浏览专题合集
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[300px] h-[380px] md:w-[380px] md:h-[480px] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20style%20illustration%20featuring%20a%20warm%20tomato%20red%20gradient%20backdrop%20with%20floating%20film%20reels%2C%20popcorn%20boxes%2C%20movie%20clapperboards%2C%20and%20glowing%20play%20button%20icons%2C%20modern%20flat%20design%20with%20subtle%20texture%2C%20entertainment%20and%20streaming%20theme%2C%20vibrant%20yet%20elegant%20composition%2C%20dark%20cinematic%20vignette%20edges%2C%20digital%20art%20style%20with%20soft%20glow%20effects&width=760&height=960&seq=hero-visual-fanqie&orientation=portrait"
                alt="番茄影视 - 高清影视免费在线观看平台主视觉"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}